<template>
    <div class="modal-card" style="width: 350px; max-width: 100%;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="margin: 0px;">Resend email</p>
        </header>
        <section class="modal-card-body resend-email-modal">
            <div class="alert alert-danger" v-if="error">
                Something went wrong. Contact hello@bugfer.com
            </div>
            <b-field label="Email">
                <b-input type="email" ref="email" v-model="email" required></b-input>
            </b-field>
        </section>
        <footer class="modal-card-foot" style="text-align: right; display: block;">
            <button class="button" type="button" @click="$parent.close()">Close</button>
            <b-button type="is-primary" v-if="!sending" @click="resendEmail()">Resend <i class="fas fa-paper-plane" style="margin-left: 5px;"></i></b-button>
            <b-button type="is-primary" v-else loading> Resend</b-button>
        </footer>
    </div>
</template>

<script>
import {resendVerificationLink} from '../logic/account'

let sending = false;
let error = false;
let email = "";

export default {
    name: 'ModalResendEmail',
    props: {},
    data(){
        return {
            sending: sending,
            email: email,
            error: error
        }
    },
    components: {},
    methods:{
        resendEmail: function(){
            this.inviting = true;
            let _this = this
            let isValid = this.$refs.email.checkHtml5Validity()
            if(isValid){
                resendVerificationLink(this.email).then(response => {
                    this.email = ""
                    this.$parent.close();
                    _this.inviting = false;
                }).catch(error => {
                    _this.error = true;
                    _this.inviting = false;
                })
            }else{
                this.inviting = false;
            }
        },
    },
}
</script>

<style scoped>
.resend-email-modal >>> .label{
    font-weight: 400;
    text-align: left;
    padding-left: 0px;
}
</style>
